import { useEffect, useState } from "react";

/**
 * @param query A media condition (e.g. `"(min-width: 900px)"`), or a `@media (...)`-prefixed
 * string such as `breakpoints.s`/`.m`/`.l` from `materials/consts.stylex.ts` — the prefix, if
 * present, is stripped, so callers can reuse the same breakpoint tokens CSS uses.
 */
export function useMedia(query: string, defaultMatches = true) {
  const [matches, setMatches] = useState(defaultMatches);
  const condition = query.replace(/^@media\s+/, "");

  useEffect(() => {
    const mediaQueryList = window.matchMedia(condition);
    let active = true;

    const listener = (e: MediaQueryListEvent) => {
      if (!active) {
        return;
      }

      setMatches(e.matches);
    };

    mediaQueryList.addEventListener("change", listener);
    setMatches(mediaQueryList.matches);

    return () => {
      active = false;
      mediaQueryList.removeEventListener("change", listener);
    };
  }, [condition]);

  return matches;
}
